import styled from 'styled-components';

export const CardsContainer = styled.div<{ isComparisonPage?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  min-height: 260px;
  flex-wrap: wrap;
  order: 4;
  @media screen and (max-width: 1024px) {
    padding: ${({ isComparisonPage }) => isComparisonPage ? '0' : '0 1.25rem'};
  }
`;

export const CardsHeading = styled.h2`
  font-size: 35px;
  line-height: 42px;
  width: 100%;
  margin: 2rem 0;
`;
